module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-3.92f8ff05.png";